import {Dictionary} from "../components/Dictionary";
import React from "react";
import {AdminComponent} from "../components/AdminComponent";
import {Util} from "../components/Util";

export class StatusInfo extends AdminComponent {
    protected dictionary: Dictionary = new Dictionary();
    protected static keyNo: number = 0;

    getKeyValue() {
        StatusInfo.keyNo++;
        return "home:" + StatusInfo.keyNo;
    }

    render() {
        const dictionary = this.dictionary;
        const statuses: string[] = ['draft', 'import-error', 'unknown-product', 'insufficient-quantity',
            'duplication-error', 'scheduled', 'address-error', 'on-hold', 'customer-error', 'open', 'b2b-open',
            'create-error', 'in-transit', 'b2b-in-transit', 'cancelled', 'sync-error', 'completed', 'close-error',
            'closed', 'error', 'archived'];

        const classNamePrefix = "col-12 col-md-6 col-lg-4";

        const getKeyValue = this.getKeyValue;

        return (
            <>
                <div className="row">
                    <h4>{this.dictionary.get['statuses']}</h4>
                    <div className="col-12">
                        <div className="alert alert-primary" role="alert">
                            {dictionary.get['statuses-info']}
                        </div>
                    </div>
                    <div className="x-form" key="orders:status-list">
                        <div className="row">
                            {statuses.map(function (elem: string) {
                                if (elem === 'newLine') {
                                    return (<div className="row" key={getKeyValue()}>&nbsp;</div>);
                                }
                                return (
                                    <p className={classNamePrefix} key={getKeyValue()}>
                                        {Util.status(elem, {style: {fontSize: '11px'}})}
                                        <span className="alert alert-primary" role="alert">
                                            {dictionary.get[elem + '-info']}
                                        </span>
                                    </p>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}